module.exports = __webpack_public_path__ + "static/assets/bd10f8b6da88cc7a3db7829fbc9dfa3a.png";